import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ContactService } from '../contact.service';

@Component({
  selector: 'app-route-delete',
  templateUrl: './route-delete.component.html',
  styleUrls: ['./route-delete.component.scss']
})
export class RouteDeleteComponent implements OnInit {

  rteDelete: any;
  constructor(public thisDialogRef: MdDialogRef<RouteDeleteComponent>,private contactService:ContactService, @Inject(MD_DIALOG_DATA) public data: any) { 
    this.rteDelete = data.rId;
    // console.log(this.rteDelete);
  }

  ngOnInit() {
    // console.log(this.data.rId);
    // console.log("Inside route delete component !!!")
  }


onCloseConfirm(){

  // console.log("inalpayloadPoint",this.rteDelete);
 
    this.thisDialogRef.close("success");
  }
onCloseCancel(){
    // console.log("cancel button clicked");
    this.thisDialogRef.close('Cancel');
}

}




// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/route-delete/route-delete.component.ts